var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "channels-item",
      class: {
        healthy: _vm.isBusiness
          ? true
          : !!(
              _vm.channelInfos[_vm.channel._id] &&
              _vm.channelInfos[_vm.channel._id].status.ready
            ),
        dead: _vm.isBusiness
          ? false
          : !(
              _vm.channelInfos[_vm.channel._id] &&
              _vm.channelInfos[_vm.channel._id].status.ready
            ),
      },
    },
    [
      _c("div", { staticClass: "first", on: { click: _vm.goToDetail } }, [
        _c(
          "div",
          { staticClass: "icon-wrapper", on: { click: _vm.goToDetail } },
          [
            _vm.isBusiness
              ? _c("WhatsappBusinessIcon", {
                  attrs: { className: "channel-icon", color: "#179d0d" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isV1
              ? _c("WhatsappV1", {
                  staticClass: "channel-icon",
                  attrs: { color: _vm.color },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isV2
              ? _c("WhatsappV2", {
                  staticClass: "channel-icon",
                  attrs: { color: _vm.color },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.smsPostacell
              ? _c("img", {
                  staticStyle: { "max-width": "50px" },
                  attrs: { src: "/static/img/postacell-logo.png" },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  theme: _vm.isDarkMode ? "light-border" : "google",
                },
                expression:
                  "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
              },
            ],
            staticClass: "channel-name",
            attrs: {
              content: "Whatsapp Channel: " + _vm.channel.name.toUpperCase(),
            },
          },
          [_vm._v("\n            " + _vm._s(_vm.channel.name) + "\n        ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _vm.whatsappModal
            ? _c(
                "IconButton",
                {
                  attrs: {
                    "on-click": function () {
                      return _vm.$router.push(_vm.broadcastRequestURL)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass: "md-icon md-icon-style",
                      attrs: { content: _vm.$t("wp.broadcast.broadcast") },
                      on: { click: function ($event) {} },
                    },
                    [_vm._v("\n                campaign")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("a-divider", { attrs: { type: "vertical" } }),
          _vm._v(" "),
          _vm.whatsappModal
            ? _c("IconButton", { attrs: { "on-click": _vm.openModal } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    staticClass: "md-icon md-icon-style",
                    attrs: { content: "Start Chat" },
                    on: { click: function ($event) {} },
                  },
                  [_vm._v("\n                forum\n            ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.smsModal
            ? _c("IconButton", { attrs: { "on-click": _vm.openSmsModal } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    staticClass: "md-icon md-icon-style",
                    attrs: { content: "SEND SMS" },
                    on: { click: function ($event) {} },
                  },
                  [_vm._v("\n                forum\n            ")]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("tour.startChat"),
            width: "1000px",
            footer: null,
          },
          on: { ok: _vm.closeModal },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("WhatsappContactList", {
            attrs: {
              channel: _vm.channel,
              "channel-id": _vm.channel._id,
              allowImport: false,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("tour.startChat"), footer: null },
          on: { ok: _vm.closeSmsModal },
          model: {
            value: _vm.smsStartChat,
            callback: function ($$v) {
              _vm.smsStartChat = $$v
            },
            expression: "smsStartChat",
          },
        },
        [
          _c(
            "div",
            { staticClass: "send-sms-v2" },
            [
              _c("SendSmsInput", {
                attrs: { "default-phone-number": _vm.phoneNumber },
                on: { sendSMS: _vm.sendSMS },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }